import { render, staticRenderFns } from "./ReviewProcessModal.vue?vue&type=template&id=0204415a&"
import script from "./ReviewProcessModal.vue?vue&type=script&lang=js&"
export * from "./ReviewProcessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports